import { useLazyQuery, useQuery } from '@apollo/client'
import { AppBar, Button, Typography, useTheme } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import AdotelSkeleton from '../../components/AdotelSkeleton'
import Breadcrumbs from '../../components/Breadcrumb'
import PageHeader from '../../components/PageHeader'
import { WALLET_QUERY } from '../../graphql/wallet'
import { PROFORMA_QUERY } from '../../graphql/walletProforma'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import ReceiptConfirmation from './Confirmation'
import ReceiptOfPayment from './ReceiptOfPayment'
import SummeryOfPayment from './SummeryOfPayment'
import TransactionList from './TransactionListTable'
import useStyles from './styles/index.styles'

const WalletProformaAdminDetails = () => {
  const classes = useStyles()
  const theme = useTheme()
  const params = useParams<{ proformaId: string }>()

  const [getWallet, { data: wallet, loading: loadingForwallet }] =
    useLazyQuery<{
      wallet: Wallet
    }>(WALLET_QUERY, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })

  const {
    data: proforma,
    loading: loadingForProformas,
    refetch
  } = useQuery<{
    proforma: Proforma
  }>(PROFORMA_QUERY, {
    onCompleted: (resp) => {
      getWallet({
        variables: {
          walletID: resp.proforma.transactions[0].walletID
        }
      })
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      proformaID: params.proformaId
    }
  })
  const walletName =
    wallet?.wallet.entity.entityType +
    '-' +
    wallet?.wallet.entity.entityName +
    '-' +
    wallet?.wallet.walletType +
    '-' +
    wallet?.wallet.currency
  const cachedLevels = useMemo(
    () => [
      {
        label: getTranslate('Invoice List'),
        link: `/adopay/invoice-list`
      },
      {
        label: proforma?.proforma.proformaNumber || ''
      }
    ],
    [walletName]
  )

  return !loadingForProformas && proforma ? (
    <div>
      <PageHeader title={getTranslate('Invoice Details')} />
      <div className={classes.root}>
        <AppBar
          className={classes.appBar}
          position="static"
          color="transparent">
          <Breadcrumbs
            levels={cachedLevels}
            loading={loadingForProformas || loadingForwallet}
          />
        </AppBar>
      </div>
      <div className={classes.headerAndButtons}>
        <div className={classes.header}>
          <Typography variant="h3" gutterBottom>
            {getTranslate('Invoice Proposal')}
          </Typography>
          <Button
            endIcon={<OpenInNewIcon />}
            variant="contained"
            color="primary"
            disabled={loadingForProformas}
            onClick={() => {}}>
            {getTranslate('Export')}
          </Button>
        </div>
      </div>
      <div className={classes.detailsContainer}>
        <div>
          <ReceiptOfPayment proforma={proforma.proforma} />
          <div className={classes.transactionsListContainer}>
            <TransactionList
              transactions={proforma?.proforma.transactions || []}
              currency={wallet?.wallet.currency}
            />
          </div>
        </div>

        <div>
          <div className={classes.summeryOfPaymentContainer}>
            {wallet && (
              <SummeryOfPayment
                proforma={proforma?.proforma}
                wallet={wallet?.wallet}
                refetch={refetch}
                creditorName={
                  proforma.proforma.transactions[0].creditorEntity?.entityType +
                  ' - ' +
                  proforma.proforma.transactions[0].creditorEntity?.entityName
                }
              />
            )}
          </div>
          <div>
            <div className={classes.proformaStatusContainer}>
              <ReceiptConfirmation />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <AdotelSkeleton
      open={loadingForProformas}
      circlesColor={theme.palette.primary.main}
      numberOfCircles={4}
    />
  )
}

export default WalletProformaAdminDetails
